import { IlocalStorageProvider } from "../../adapters/driven/providers/localStorageProvider";
import { IClinicRepository } from "../../adapters/driven/repositories/clinicRepository";

export const ClinicServiceImplFactory = ({
  clinicRepository,
  localStorageProvider,
  notificationService,
}: {
  clinicRepository: IClinicRepository;
  localStorageProvider: IlocalStorageProvider;
  notificationService: INotificationService;
}) => {
  const getMyClinics: IGetMyClinic = async () => {
    try {
      const response = await clinicRepository.getClinicID();
      let sortedClinicList: IClinic[] = [];
      if (response) {
        sortedClinicList = [...response];
        sortedClinicList = sortedClinicList
          .filter((clinic) => clinic.name.length)
          .sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          });
      }
      return {
        success: true,
        data: sortedClinicList,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  };

  const setSelectedClinic: ISetSelectedClinic = async ({
    id,
    clinicList,
    notificationSettings,
  }) => {
    await notificationService.setNotificationSetting(notificationSettings);
    return clinicList.find((item) => item.id === id) || null;
  };

  const getSelectedClinic: IGetSelectedClinic = ({ clinicList }) => {
    const selectedClinic = localStorageProvider.get("selectedClinic");

    if (selectedClinic) {
      return (
        clinicList.find((item) => item.id === Number(selectedClinic)) || null
      );
    }
    return null;
  };

  const setDefaultClinic: IGetSelectedClinic = ({ clinicList }) => {
    const clinic = clinicList[0];
    if (clinic) {
      localStorageProvider.set("selectedClinic", clinic.id.toString());
      return clinic;
    }
    return null;
  };

  const getClinicFloor: IGetClinicFloor = async ({ clinicId }) => {
    try {
      const response = await clinicRepository.getClinicFloor({
        clinic_id: clinicId,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  };

  const setClinicFloor: ISetClinicFloor = async (obj) => {
    try {
      const response = await clinicRepository.setClinicFloor({
        clinic_id: obj.clinicId,
        floor_ids: obj.floor_ids,
      });
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  };

  const logError: ILogError = async (obj) => {
    try {
      const response = await clinicRepository.logError(obj);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  };

  const updateFacilityInformation: IUpdateFacilityInformation = async (obj) => {
    try {
      const response = await clinicRepository.updateFacilityInformation(obj);
      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error,
      };
    }
  };

  return {
    getClinicFloor,
    getMyClinics,
    getSelectedClinic,
    setDefaultClinic,
    setSelectedClinic,
    setClinicFloor,
    logError,
    updateFacilityInformation,
  };
};
